var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside-cta aside-youtube aside-box has-border"},[_c('img',{staticClass:"clickable",attrs:{"src":_vm.youtubeImagePath,"alt":""},on:{"click":_vm.youtubeRedirection}})])}
var staticRenderFns = []

export { render, staticRenderFns }